// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"thLd54jUvUI4","loading":"TzGZ7H9nAFz8"};